export const TEXT_EXTRACTION_POLL_INTERVAL_MS = 5000;

const ACTIVE_STATUSES = ['QUEUED', 'TEXTEXTRACTIONINPROGRESS'];

export const isTextExtractionActive = (status?: string | null): boolean =>
  !!status && ACTIVE_STATUSES.includes(status);

export const isTextExtractionFailed = (status?: string | null): boolean => status === 'FAILED';
